import { MimeType, FileIconFont } from '../enums';
export const getFileIconByType = (type, thumbnailUrl) => {
    switch (type) {
        case MimeType.APPLICATION_PDF:
            return FileIconFont.PDF;
        case MimeType.VIDEO_MP4:
        case MimeType.VIDEO_MPEG:
        case MimeType.VIDEO_AVI:
        case MimeType.VIDEO_MOV:
        case MimeType.VIDEO_WMV:
            return thumbnailUrl ? undefined : FileIconFont.VIDEO;
        case MimeType.AUDIO_MPEG:
            return FileIconFont.AUDIO;
        case MimeType.APPLICATION_MS_EXCEL:
        case MimeType.APPLICATION_OPEN_OFFICE_EXCEL:
            return FileIconFont.EXCEL;
        case MimeType.APPLICATION_MS_WORD:
        case MimeType.APPLICATION_OPEN_OFFICE_WORD:
            return FileIconFont.WORD;
        case MimeType.IMAGE_JPEG:
        case MimeType.IMAGE_PNG:
        case MimeType.IMAGE_GIF:
        case MimeType.IMAGE_BMP:
            return undefined;
        default:
            return FileIconFont.GENERIC;
    }
};
//# sourceMappingURL=IconUtils.js.map